
import IRoutes from '../interfaces/IRoutes';
import Dashboard from '../pages/dashboard/Dashboard';
import NotFound from '../pages/notFound/NotFound';
import MainContainer from '../components/template/mainContainer/MainContainer';
import Profile from '../pages/profile/Profile';
import Login from '../pages/login/Login';
import { SatpasDeviceRoute } from './satpasDevice';
import { MySubscribtionRoute } from './mySubscribtion';
import { LogEventsRoute } from './logEvents';
import { AdminManagementRoute } from './adminManagement';
import { LivenessDeviceRoute } from './livenessDevice';
import { LogResultRoute } from './logResult';
import DailyStatics from '../components/molecules/dashboard/DailyStatics';

const routes: IRoutes[] = [
  {
    element: <MainContainer />,
    path: '/',
    errorElement: <NotFound />,
    children: [
      {
        element: <Dashboard />,
        index: true,
      },
      {
        element: <DailyStatics />,
        path: '/statistics'
      },
      {
        element: <Login />,
        path: '/login',
      },
      {
        element: <Profile />,
        path: '/profile',
      },
      ...SatpasDeviceRoute,
      ...MySubscribtionRoute,
      ...LogEventsRoute,
      ...LogResultRoute,
      ...AdminManagementRoute,
      ...LivenessDeviceRoute
    ],
  },
];

export default routes;
